import * as THREE from "three";
import { restoreActiveArrays } from "./addProductCard";

export function setCameraOnRoom() {
    const is2DMode = servObj.building._is2dMode;

    const orthoCamera = servObj.scene.orthoCamera;
    const perspectiveCamera = servObj.scene.perspectiveCamera;
    const activeCamera = is2DMode ? orthoCamera : perspectiveCamera;

    // Включаем pan
    if (activeCamera.controls) {
        activeCamera.controls.truckSpeed = 1;
    }

    servObj.scene.setActiveCamera(activeCamera);

    if (is2DMode) {
        // Устанавливаем позицию ортографической камеры
        orthoCamera.position.set(0, 5, 0);
        activeCamera.controls.azimuthRotateSpeed = 0;
        activeCamera.controls.polarRotateSpeed = 0;
        // Смотрим в центр сцены (или нужную точку)
        activeCamera.controls.setLookAt(0, 5, 0, 0, 0, 0);

        const boundary = new THREE.Box3(
            new THREE.Vector3(-Infinity, 0, -Infinity), // min: не ниже пола
            new THREE.Vector3(Infinity, Infinity, Infinity), // max: без ограничений вверх
        );
        activeCamera.controls.setBoundary(boundary);
        activeCamera.controls.boundaryEnclosesCamera = true;
    } else {
        // perspectiveCamera.filmOffset = 0;
        perspectiveCamera.updateProjectionMatrix();

        const boundary = new THREE.Box3(
            new THREE.Vector3(-Infinity, 0, -Infinity), // min: не ниже пола
            new THREE.Vector3(Infinity, Infinity, Infinity), // max: без ограничений вверх
        );
        activeCamera.controls.setBoundary(boundary);
        activeCamera.controls.boundaryEnclosesCamera = true;

        activeCamera.controls.minPolarAngle = 0;
        activeCamera.controls.maxPolarAngle = Math.PI / 2;

        activeCamera.controls.setLookAt(-11.54551523854972, 6.588234921725335, 11.769283150943561, 0, 0, 0);
    }
}

export function setCameraOnEditMode(editObj, isRestored = true) {
    if (!editObj) {
        console.warn("Нет объекта для редактирования");
    }

    const camera = servObj.scene.perspectiveCamera;
    if (!camera) return;
    const cameraControls = camera.controls;

    // Отключаем pan
    // cameraControls.truckSpeed = 0;

    cameraControls.minPolarAngle = 0;
    cameraControls.maxPolarAngle = Math.PI / 2;

    const boundary = new THREE.Box3(
        new THREE.Vector3(-Infinity, 10, -Infinity), // min: не ниже пола
        new THREE.Vector3(Infinity, Infinity, Infinity), // max: без ограничений вверх
    );
    cameraControls.setBoundary(boundary);
    cameraControls.boundaryEnclosesCamera = true;

    // Смещение камеры
    camera.updateProjectionMatrix();

    servObj.scene.setActiveCamera(camera);

    if (editObj.position.y < 10) {
        servObj.rememberedPosition = editObj.position.clone();
        servObj.rememberedRotation = editObj.rotation.clone();
    }
    editObj.rotation.set(0, 0, 0);

    setTimeout(() => {
        editObj.rotation.set(0, 0, 0);
    }, 10);

    if (isRestored) {
        restoreActiveArrays(editObj);
        restoreInitialPivotAndPosition(editObj);
    }

    if (editObj.name.includes("stoyka")) {
        cameraControls.setLookAt(
            -2.4999476499615434,
            11.566350561339176,
            2.493075218219242,
            0.10262303862735783,
            10.617665805015376,
            -0.1453284696119749,
        );
    } else {
        const hasKomplektStoek =
            !!servObj.activeKomplektStoek.length || editObj.name.includes("stoyka") || editObj.name.includes("ostrov");

        const isStul = editObj.name.includes("stul");
        const isShkaf = editObj.name.includes("shkaf");

        const distance = hasKomplektStoek ? 4.5 : isStul ? 2 : isShkaf ? 4.2 : 3.7; // оставляем как есть или чуть увеличим
        const height = hasKomplektStoek ? 2 : isStul ? 1.5 : isShkaf ? 1.2 : 2; // уменьшили, чтобы камера была ниже
        const angle = isShkaf ? 0 : (7 * Math.PI) / 4;

        const target = editObj.position.clone();
        const offset = new THREE.Vector3(
            distance * Math.sin(angle), // X
            height, // Y
            distance * Math.cos(angle), // Z
        );

        const cameraPos = target.clone().add(offset);

        const lookAtYOffset = isShkaf ? 1 : hasKomplektStoek ? 0.75 : 0.5;

        cameraControls.setLookAt(cameraPos.x, cameraPos.y, cameraPos.z, target.x, target.y + lookAtYOffset, target.z);
    }
}
export function setUpViewPort() {
    const camera = servObj.scene.perspectiveCamera;
    if (!camera) return;
    const cameraControls = camera.controls;
    const editObj = servObj.redactorModeObject;

    const pos = cameraControls.getPosition();
    const { y, z } = pos;
    if (y <= 12 && z <= 5) {
        const distance = 4.5;
        const height = 2;
        const angle = (7 * Math.PI) / 4;

        const target = editObj.position.clone();
        const offset = new THREE.Vector3(
            distance * Math.sin(angle), // X
            height, // Y
            distance * Math.cos(angle), // Z
        );

        const cameraPos = target.clone().add(offset);

        const lookAtYOffset = 0.75;

        cameraControls.setLookAt(
            cameraPos.x,
            cameraPos.y,
            cameraPos.z,
            target.x,
            target.y + lookAtYOffset,
            target.z,
            true,
        );
    }
}
function restoreInitialPivotAndPosition(obj) {
    if (!obj.userData.initialPivotWorld) return;

    // Получаем текущий мировой пивот
    const currentPivot = new THREE.Vector3();
    obj.getWorldPosition(currentPivot);

    // Считаем разницу между исходным и текущим пивотом
    const shift = {
        x: obj.userData.initialPivotWorld.x - currentPivot.x,
        y: obj.userData.initialPivotWorld.y - currentPivot.y,
        z: obj.userData.initialPivotWorld.z - currentPivot.z,
    };

    // Смещаем объект так, чтобы его пивот совпал с исходным
    obj.position.x += shift.x;
    obj.position.y += shift.y;
    obj.position.z += shift.z;

    // Восстанавливаем позицию (если нужно)
    if (obj.userData.editModePos) {
        // const objectSize = extractSize(obj.name);
        // const objectDepth = objectSize.split("x")[1] || 0;
        // const TABLE_Z_OFFSET = objectDepth === "700" ? 0.35 : objectDepth === "900" ? 0.45 : 0;

        obj.position.x = 0;
        obj.children.forEach((ch) => ((ch.position.x = 0), (ch.position.z = 0)));

        obj.position.y = obj.userData.editModePos.y;
        // obj.position.z = TABLE_Z_OFFSET;
        obj.position.z = 0;
    }

    obj.updateMatrixWorld(true);
}
